import AppConfig from "config";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Flex,
  Button,
} from '@chakra-ui/react';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import { useParams } from 'react-router-dom';
import TranscriptController from './controllers/TranscriptController';
import ChatComponent from './chat_component';
import ChatModal from "components/Modal";

function TranscriptsView3({ idtranscripts }) {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchId, setSearchId] = useState('');
  const textColor = useColorModeValue('gray.700', 'white');
  const { Audit_id } = useParams();

  useEffect(() => {
    const fetchData = async (idtranscripts) => {
      try {
        const jwtToken = localStorage.getItem('access_token');
        const profiles = await TranscriptController.getTranscriptsByAudit(jwtToken, idtranscripts);
        setData(profiles);
        setOriginalData(profiles);
        setFilteredData(profiles);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData(idtranscripts);
  }, [Audit_id, idtranscripts]);

  const handleSearch = () => {
    if (!searchId.trim()) {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        (transcript) => transcript.idtranscripts.toString() === searchId
      );
      setFilteredData(filtered);
    }
  };

  useEffect(() => {
    if (!searchId.trim()) {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        (transcript) => transcript.idtranscripts.toString() === searchId
      );
      setFilteredData(filtered);
    }
  }, [searchId, originalData]);

  return (
    <Flex direction="column" pt={{ base: '120px', md: '5px', width: '100%' }} overflowY="auto">
      <Card overflowX={{ sm: 'auto', xl: 'hidden' }}>
        <CardHeader p="6px 0px 22px px">
          <Flex flexDirection="column" mb={4}>
            <Text fontSize="xl" color={textColor} fontWeight="bold" mt={4}>
              Interagir
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <Table variant="simple" size="md">
            <Thead>
              <Tr>
                <Th width="40px">ID</Th>
                <Th width="100px">Data</Th>
                <Th width="100px">Play</Th>
                <Th width="30px">Ficha</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData.map((transcript) => (
                <TranscriptsRow
                  key={transcript.idtranscripts}
                  transcript={transcript}
                  setData={setData}
                  handleSearch={handleSearch}
                  searchId={searchId}
                  openChatModal={() => openChatModal(transcript.idtranscripts)}
                />
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
      <Flex flex={1} justifyContent="center">
      </Flex>
    </Flex>
  );
}

function TranscriptsRow({
  transcript,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [messagesLoaded, setMessagesLoaded] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const toggleChatVisibility = () => {
    setIsChatVisible((prevVisibility) => !prevVisibility);

    if (!messagesLoaded && !isChatVisible) {
      fetchMessages();
      setMessagesLoaded(true);

      const id = setInterval(fetchMessages, 2000);
      setIntervalId(id);
    } else if (isChatVisible && intervalId !== null) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  };

  useEffect(() => {

    return () => {
      console.log("Cleanup function executed");
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  const fetchMessages = async () => {
    try {
      const jwtToken = localStorage.getItem('access_token');
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + 'chat/get_messages',
        {
          idtranscripts: transcript.idtranscripts,
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      const messagesFromEndpoint = response.data.result || [];
      console.log(response.data.result);

      setChatMessages(messagesFromEndpoint);
    } catch (error) {
      console.error('Erro ao buscar mensagens do GPT:', error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const toggleExpand = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const getDisplayText = () => {
    if (isExpanded) {
      return transcript.transcript_text;
    }
    const lines = transcript.transcript_text.split('\n');
    return transcript.transcript_text.slice(0, 720) + ' ...';
  };

  const interactWithGPT = async (idtranscript, newMessage) => {
    try {
      const jwtToken = localStorage.getItem('access_token');
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + 'chat/send_message',
        {
          idtranscripts: idtranscript,
          message: newMessage,
          user: 'Você',
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

    } catch (error) {
      console.error('Erro ao interagir com o GPT:', error);
    }
  };

  const audioUrl = `data:audio/mp3;base64,${transcript.base64_content}`;

  return (
    <>
      <Tr>
        <Td style={{ verticalAlign: 'top' }}>{transcript.idtranscripts}</Td>
        <Td style={{ verticalAlign: 'top' }}>
          {formatDate(transcript.date_start)}
        </Td>
        <Td style={{ verticalAlign: 'top' }}>
          <audio controls>
            <source src={audioUrl} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
        </Td>
        <Td style={{ verticalAlign: 'top' }}>{transcript.audit_nome}</Td>
      </Tr>
      <Tr>
        <Td style={{ verticalAlign: 'top', whiteSpace: 'pre-line' }} colSpan={4}>
          {getDisplayText()}
        </Td>
        <Td style={{ verticalAlign: 'top', textAlign: 'center' }}>
          <Button size="sm" onClick={toggleExpand}>
            {isExpanded ? 'Recolher' : 'Expandir'}
          </Button>
        </Td>
        <Td style={{ verticalAlign: 'top', textAlign: 'center' }}>
          <Button size="sm" onClick={toggleChatVisibility}>
            {isChatVisible ? 'Chat Exibido' : 'Exibir Chat'}
          </Button>
          {isChatVisible && (
            <ChatModal isOpen={isChatVisible} onClose={toggleChatVisibility}>
              <ChatComponent
                messages={chatMessages}
                idtranscript={transcript.idtranscripts}
                setMessages={setChatMessages}
                user={transcript.user}
                onSendMessage={(newMessage) => interactWithGPT(transcript.idtranscripts, newMessage)}
              />
            </ChatModal>
          )}
        </Td>
      </Tr>
    </>
  );
}

export default TranscriptsView3;